import { useEffect, useState } from 'react';

import type { NotificationTemplate } from '../helpers/types';
import type { NotificationsFilters, NotificationType } from '../types';

export const useUserNotificationsFilters = ({
  notifications,
}: {
  notifications: NotificationTemplate[];
}) => {
  const [filters, setFilters] = useState<NotificationsFilters>({
    types: [],
    search: '',
    dateRange: [null, null],
  });
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const [filteredNotifications, setFilteredNotifications] = useState<NotificationTemplate[]>([]);

  useEffect(() => {
    const applyFilters = () => {
      const { search, types, dateRange } = filters;

      const filtered = notifications?.filter((notificationTemplate) => {
        const { title, description, creationDate, notification } = notificationTemplate;

        const matchesSearch =
          !search.toLocaleLowerCase() ||
          description.plainText.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
          title.titlePrefix.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
          title.titleTopic.toLocaleLowerCase().includes(search.toLocaleLowerCase());

        const notificationType = notification.getType().toLocaleLowerCase() as NotificationType;
        const matchesType = types.length === 0 || types.includes(notificationType);

        const notificationCreationDate = new Date(creationDate);
        const matchesDateRange =
          !dateRange[0] ||
          !dateRange[1] ||
          (dateRange[0] &&
            dateRange[1] &&
            dateRange[0] <= notificationCreationDate &&
            notificationCreationDate <= dateRange[1]);

        return matchesSearch && matchesType && matchesDateRange;
      });

      return filtered;
    };

    const { search, types, dateRange } = filters;
    const hasActiveFiltersTemp = !!(search || !!types.length || dateRange[0] || dateRange[1]);
    setHasActiveFilters(hasActiveFiltersTemp);

    const filtered = applyFilters();
    setFilteredNotifications(filtered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return {
    filters,
    setFilters,
    filteredNotifications,
    hasActiveFilters,
  };
};
